<template>
  <div class="main-container">
    <div class="page-top-title">
      <p class="title">{{ reportName }}</p>
      <div class="page-top-right">
        <div class="item">
          结算日期：
          <span class="num">{{ settlementDate }}</span>
        </div>
        <div class="item settlement-status">
          结算状态：
          <div v-if="detailData.settlementStatus == 0" class="tag-settled">待结算</div>
          <div v-else class="tag-be">已结算</div>
        </div>
      </div>
    </div>
    <div class="statistics-box" v-if="reportType == '4-2' || reportType == '4-1'">
      <p>汇总数据</p>
      <div class="item" v-if="reportType == '4-2'">
        件数：
        <span class="num">{{ statisticsObj.policyNum || 0 }}</span
        >件
      </div>

      <div class="item" v-if="reportType == '4-1' && productType == 2">
        保单数：
        <span class="num">{{ statisticsObj.policyNum || 0 }}</span
        >个
      </div>
      <div class="item" v-if="reportType == '4-1' && productType == 2">
        批单数：
        <span class="num">{{ statisticsObj.billNum || 0 }}</span
        >个
      </div>
      <div class="item">
        保费：
        <span class="num">{{ statisticsObj.fee || 0 }}</span
        >元
      </div>
      <div class="item">
        标准保费：
        <span class="num">{{ statisticsObj.foldFyb || 0 }}</span
        >元
      </div>
      <div class="item">
        奖励：
        <span class="num">{{ statisticsObj.activityIncome || 0 }}</span
        >元
      </div>
    </div>
    <div class="statistics-box" v-else-if="reportType == '2-2'">
      <p>汇总数据</p>
      <div class="item">
        推荐人数量：
        <span class="num">{{ statisticsObj.userNum || 0 }}</span
        >人
      </div>
      <div class="item">
        被推荐人：
        <span class="num">{{ statisticsObj.beRecommendedNum || 0 }}</span
        >人
      </div>
    </div>
    <div class="statistics-box" v-else-if="reportType == '5-2'">
      <p>汇总数据</p>
      <div class="item">
        签约人数：
        <span class="num">{{ statisticsObj.userNum || 0 }}</span
        >人
      </div>
      <div class="item">
        总奖励：
        <span class="num">{{ statisticsObj.activityIncome || 0 }}</span
        >人
      </div>
    </div>
    <div class="statistics-box" v-else>
      <p>汇总数据</p>
      <div class="item">
        保费：
        <span class="num">{{ statisticsObj.fee || 0 }}</span
        >元
      </div>
      <div class="item">
        标准保费：
        <span class="num">{{ statisticsObj.foldFyb || 0 }}</span
        >元
      </div>
      <div class="item">
        基础费用：
        <span class="num">{{ statisticsObj.baseFirstIncome || 0 }}</span
        >元
      </div>
      <div class="item">
        奖励：
        <span class="num">{{ statisticsObj.activityIncome || 0 }}</span
        >元
      </div>
    </div>

    <Tabs v-model="tabVal" @on-click="clickTabs" class="tab">
      <TabPane :label="reportType == '4-2' || reportType == '4-1' ? '业务员明细' : '推荐人明细'" name="1"></TabPane>
      <TabPane label="按机构汇总" name="2"></TabPane>
    </Tabs>

    <div class="search-container" v-if="tabVal == '1'">
      <div class="search-box min" v-if="reportType != '4-1'">
        <div class="input-item">
          <span class="label">业务员</span>
          <Select placeholder="请选择" v-model="salesmanId" clearable filterable>
            <Option v-for="(item, i) in userList" :key="i" :value="item.id">
              <i class="dian" :class="{ red: item.workingState == 0, orange: item.isSus == 1 }"></i>
              {{ item.staffNo ? item.staffNo + '-' + item.name : item.name }}
            </Option>
          </Select>
        </div>
        <div class="btn-item btn-box">
          <Button type="primary" @click="searchAjax">查询</Button>
        </div>
      </div>
    </div>

    <loading :isShow="listLoading" />
    <div class="table-box">
      <Table ref="table" :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="userName_staffNo">
          <div class="name-status">
            <div class="user-box">
              <i class="dian" :class="{ red: row.workingState == 0 || row.isSus == 1 }" v-if="row.userName"></i>
              <span class="user-name">{{ row.staffNo }}</span>
              <span v-if="row.staffNo">/</span>
              <span class="user-name">{{ row.userName }}</span>
            </div>
          </div>
        </template>

        <template slot-scope="{ row }" slot="recommendname_staffNo">
          <div class="name-status">
            <div class="user-box">
              <i class="dian" :class="{ red: row.recommendWorkingState == 0, orange: row.isSus == 1 }" v-if="row.recommendName"></i>
              <span class="user-name">{{ row.recommendStaffNo }}</span>
              <span v-if="row.recommendStaffNo">/</span>
              <span class="user-name">{{ row.recommendName }}</span>
            </div>
          </div>
        </template>

        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="detailsPage(row)" v-if="reportType == '2-2'">增员明细</span>
          <span class="table-btn" @click="detailsPage(row)" v-else>{{ reportType == '4-2' || reportType == '4-1' ? '明细' : '保单明细' }}</span>
        </template>
      </Table>
    </div>
    <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center; margin-top: 20px" />

    <div>
      <Button class="btn" @click="back('/financialManage/activitySettlement')" v-if="step == 2">返回</Button>
      <Button class="btn" @click="backOperate" v-if="detailData.settlementStatus == 0">上一步</Button>
      <Button class="btn" @click="settledStep" v-if="detailData.settlementStatus == 1">上一步</Button>
      <Button class="btn" @click="exportReport">导出报表</Button>
      <Button type="primary" class="btn" @click="settlement" v-if="detailData.settlementStatus == 0">结算</Button>
      <Button type="primary" class="btn" v-else @click="resettlement">撤回结算</Button>
    </div>
  </div>
</template>

<script>
import { common, pageTool } from '@/api/mixins';
import { config } from './step2.config.js';
import filter from '@/api/filter';

export default {
  mixins: [common, pageTool, config],
  props: {
    backData: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      reportId: null,
      step: null,
      reportName: '',
      settlementDate: '',
      reportType: '',
      statisticsObj: {},
      detailData: {},
      tabVal: '1',
      tableData: [],
      userList: [],
      salesmanId: '',
      total: null,
      activityDetailData: {},
    };
  },
  created() {
    const { reportId, settlementDate, reportName, step, activityType, type, productType } = this.$route.query;
    this.reportId = reportId;
    this.reportName = reportName;
    this.settlementDate = settlementDate;
    this.step = step;
    this.productType = productType;
    this.reportType = type + '-' + activityType;
    if (reportId) {
      this.clickTabs(this.tabVal);
    }
    this.getUserList();
  },
  methods: {
    async setData() {
      const { reportId, settlementDate, reportName, reportType, productType, activityType, type } = this.backData;
      this.reportId = reportId;
      this.reportName = reportName;
      this.settlementDate = settlementDate;
      this.reportType = reportType;
      this.productType = productType;
      this.reportType = type + '-' + activityType;
      await this.clickTabs(this.tabVal);
      await this.getUserList();
    },
    
    clickTabs() {
      this.pageNum = 1;
      this.getList();
      this.getDetailData();
      this.getStatisticsData();

      if (this.reportType == '4-2' || (this.reportType == '4-1' && this.productType == 1)) {
        this.columns = this.columns.filter(item => item.title != '保单数' && item.title != '批单数');
      } else if (this.reportType == '4-1' && this.productType == 2) {
        this.columns = this.columns.filter(item => item.title != '件数');
      }
    },

    // 获取当前机构业务员
    getUserList() {
      this.$http({
        url: '/buz/userBase/getByOrgIds',
        type: 'POST',
        data: {
          orgaList: []
        }
      }).then(res => {
        this.userList = res.data;
      });
    },

    // 获取结算报表详情
    getDetailData() {
      this.$http({
        url: '/buz/userSettlementReport/read/detail',
        type: 'GET',
        data: {
          id: this.reportId
        }
      }).then(res => {
        this.detailData = res.data;
        // 梯度
        if (res.data.type == 4 && res.data.activityType == 2) {
          this.getActivityDetail(res.data.activityIdList[0]);
        } else {
          this.columns = this.columns.filter(item => item.title != '基础费用');
        }
      });
    },

    // 获取活动详情
    getActivityDetail(id) {
      this.$http({
        url: '/buz/merchantActivity/detail',
        type: 'GET',
        data: {
          id
        }
      }).then(res => {
        this.activityDetailData = res.data;
        if (res.data.rewardType != 1) {
          // 非加费
          this.columns = this.columns.filter(item => item.title != '基础费用');
        }
      });
    },

    // 统计
    getStatisticsData() {
      this.$http({
        url: '/buz/userSettlementDetail/statistics',
        type: 'POST',
        data: {
          reportId: this.reportId,
          userId: this.salesmanId
        }
      }).then(res => {
        if (res.data) {
          this.statisticsObj = res.data;
        }
        this.setColumns();
      });
    },

    getList() {
      this.listLoading = true;
      this.$http({
        url: '/buz/userSettlementDetail/read/page',
        type: 'POST',
        data: {
          reportId: this.reportId,
          groupType: this.tabVal,
          userId: this.salesmanId,
          pageNo: this.pageNum,
          pageSize: this.pageSize
        }
      })
        .then(res => {
          this.total = res.total;
          this.tableData = res.data;
          this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },

    //  详情
    detailsPage(row) {
      this.openPageTabTags('/financialManage/activitySettlement/detail', {
        reportId: this.reportId,
        tabVal: this.tabVal,
        orgId: row.orgId,
        userId: row.userId,
        settlementDate: this.settlementDate,
        userName: row.staffNo + '/' + row.userName,
        groupName: row.groupName,
        orgName: row.orgName,
        entryTime: filter.filterTime(row.entryTime, 'YYYY-MM-DD'),
        productType: this.productType,
        reportType: this.reportType,
        activityIncome: row.activityIncome,
        conditionalIndicator: this.activityDetailData.conditionalIndicator,
        rewardType: this.activityDetailData.rewardType,
        beRecommendedNum: row.beRecommendedNum,
        userNum: row.userNum
      });
    },

    // 上一步
    backOperate() {
      if (!this.$units.pointAction('offline_81_4_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$http({
        url: '/buz/userSettlementDetail/rollback',
        type: 'POST',
        data: {
          reportId: this.reportId
        }
      }).then(res => {
        this.$emit('backPage', { reportId: this.reportId, isAdd: 0, settled: false });
      });
    },

    // 已结算上一步
    settledStep() {
      this.$emit('settledStep', { reportId: this.reportId, isAdd: 0, settled: true });
    },

    // 导出报表
    exportReport() {
      if (!this.$units.pointAction('offline_81_4_3')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$units.downloadFile('/buz/userSettlementDetail/export', { reportId: this.reportId }, 'POST');
    },

    // 结算
    settlement() {
      if (!this.$units.pointAction('offline_81_4_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$notice.inquiry('您确定结算吗?').then(() => {
        this.$http({
          url: '/buz/userSettlementReport/settlement',
          type: 'POST',
          data: {
            id: this.reportId
          }
        }).then(res => {
          this.getDetailData();
          this.$notice.success('结算成功');
        });
      });
    },

    // 撤回结算
    resettlement() {
      if (!this.$units.pointAction('offline_81_4_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      if (this.detailData.releaseStatus == '1') {
        this.$http({
          url: '/buz/userSettlementReport/resettlement',
          type: 'POST',
          data: {
            id: this.reportId
          }
        }).then(res => {
          this.getDetailData();
          this.$notice.success('撤回成功');
        });
      } else {
        this.$notice.inquiry('您确定撤回结算吗?').then(() => {
          this.$http({
            url: '/buz/userSettlementReport/resettlement',
            type: 'POST',
            data: {
              id: this.reportId
            }
          }).then(res => {
            this.getDetailData();
            this.$notice.success('撤回成功');
          });
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.page-top-title {
  display: flex;
  font-size: 15px;
  .title {
    font-size: 16px;
    color: #3c464f;
    font-weight: bold;
  }
  .page-top-right {
    display: flex;
    align-items: center;
    margin-left: auto;
    .item {
      color: #515c6f;
      font-size: 14px;
      margin-left: 20px;
    }
    .settlement-status {
      margin-top: 1px;
      margin-left: 20px;
      display: flex;
      .tag-settled {
        width: 55px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        border-radius: 2px;
        font-size: 13px;
        color: #e3461f;
        border: 1px solid #ffc1b2;
        background: #fff5f2;
      }
      .tag-be {
        width: 55px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        border-radius: 4px;
        font-size: 13px;
        color: #35bf3f;
        border: 1px solid #abeaae;
        background: #f6fcf4;
      }
    }
  }
}
.statistics-box {
  margin-top: 20px;
  display: flex;
  color: #333;
  .item {
    margin-left: 60px;
    font-weight: bold;
    .num {
      color: #ff7134;
    }
  }
}
.tab {
  margin-top: 10px;
}
.dian {
  display: inline-block;
  width: 5px;
  height: 5px;
  background: #35bf3f;
  border-radius: 50%;
  margin-right: 4px;
  vertical-align: top;
  transform: translateY(7px);
  &.red {
    background: #e3461f;
  }
  &.orange {
    background: #ff9900 !important;
  }
}
.name-status {
  align-items: center;
  /deep/ .user-box {
    font-size: 12px;
    .dian {
      display: inline-block;
      flex-shrink: 0;
      width: 5px;
      height: 5px;
      background: #35bf3f;
      border-radius: 50%;
      margin-right: 4px;
      &.red {
        background: #e3461f;
      }
    }
    &.text {
      color: #515c6f;
    }
    .user-name {
      font-size: 13px;
      &.dashed {
        border-bottom: 1px dashed #236dff;
      }
      &.line {
        border-bottom: 1px solid #236dff;
      }
    }
    i {
      color: #bababa;
      font-size: 13px;
    }
    .iconduichang {
      margin-left: 4px;
    }
    &.no-token {
      color: #515c6f;
      .user-name {
        cursor: auto;
      }
    }
  }
}
</style>
